import React, { Component, useEffect, useState } from 'react';
import { getValuesMetrics } from '../../util/metricsAPI';
import {
  normalizeAnglesLikeSeries,
  resolveSampleRateHz,
  shouldLogAngleSeriesInstrumentation,
} from '../../util/metricSeriesNormalize';
import CanvasJSReact from "@canvasjs/react-charts";
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
//this version applies only to the report page

function DisplayChartv2(props) {
    const [options, setOptions] = useState({
        zoomEnabled: true,
        exportEnabled:true,
        animationEnabled: true,
        responsive: true,
        axisY: {
          title: "Degrees",
        },
        axisX: {
          title: "Time(s)",
          stripLines: [
            {
              startValue: 0,
              endValue: 0.1,
              color: "#000000",
            },
          ],
        },
        rangeChanged: function (e) {
        //   handleRangeChange(e, this);
        },
        data: [],
      });
    useEffect(()=>{
        getValuesMetrics(props.trial_id,'angles',props.name).then(res=>{
            if (!res || !res.values) return;
            const resNorm = normalizeAnglesLikeSeries(res, {
              trialId: props.trial_id,
              metricName: props.name,
              logDebug: shouldLogAngleSeriesInstrumentation(props.trial_id),
            });
            const videoDur =
              props.video_duration > 0 && !Number.isNaN(props.video_duration)
                ? props.video_duration
                : null;
            const hz = resolveSampleRateHz(
              resNorm,
              (resNorm.values || []).length,
              videoDur
            );
        const linePoints = (resNorm.values || []).map((data, idx) => ({
          x: idx / hz,
          y: data,
        }));
        const histogramPoints = (resNorm.values || []).map((data) => ({ x: data }));
        // setGraphData({ linePoints, histogramPoints });
        linePoints.forEach((obj, index) => {
          obj.y = obj.y[0];
        });
        let data = [
          {
            type: "line",
            dataPoints: linePoints,
            // click: dataClickHandler,
            color: "#63C7CF",
          },
        ];
        setOptions({ ...options, data: data });
        })
    },[])
    return <div  style={{height:'500px',width:'100%',marginTop:'10px',display:props.isSelected?'':'none'}}>
        <CanvasJSChart containerProps={{ width: '100%',maxWidth:'100%',backgroundColor:'#000000', height: '100%' }} options={options} />

    </div>;
}

export default DisplayChartv2;